import { render, staticRenderFns } from "./HermesToggle.vue?vue&type=template&id=44cf4952"
import script from "./HermesToggle.ts?vue&type=script&lang=ts&external"
export * from "./HermesToggle.ts?vue&type=script&lang=ts&external"
import style0 from "./HermesToggle.scss?vue&type=style&index=0&prod&module=styles&lang=scss&external"




function injectStyles (context) {
  
  this["styles"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports